import ScrollReveal from "@/components/feature/ScrollReveal";

const stats = [
  { value: "18+", label: "Years in IT", suffix: "" },
  { value: "120", label: "Enterprise Clients", suffix: "+" },
  { value: "45", label: "Certified Engineers", suffix: "+" },
  { value: "99.9", label: "Uptime SLA", suffix: "%" },
];

export default function StatsSection() {
  return (
    <section className="w-full py-10 md:py-14 bg-white dark:bg-dark-bg border-b border-gray-100 dark:border-dark-border">
      <div className="px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, i) => (
            <ScrollReveal key={stat.label} delay={i + 1}>
              <div className="text-center">
                <div className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-500 mb-1">
                  {stat.value}
                  <span className="text-brand-400">{stat.suffix}</span>
                </div>
                <p className="text-xs md:text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  {stat.label}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}